import React, { useEffect } from "react";
import ImageSlider from "../components/ImageSlider";
import BestSellers from "../components/BestSellers";
import FeaturedBrands from "../components/FeaturedBrands";
import Recommendations from "../components/Recommendations";
import "../styles/Home.css";
import Trending from "../components/Trending";
import Popup from "../components/Popup";

function Home() {
  useEffect(() => {
    document.title = "K-Shop";
  }, []);
  return (
    <>
      <Popup />
      <div className="wrapper">
        <div className="content">
          <ImageSlider />
          <BestSellers className="scroll-home" />
          <Recommendations className="scroll-home" />
          {/* Shop by category: re-enable with import ShopCategories + <ShopCategories className="scroll-home" /> */}
          <Trending />
        </div>
        <div className="brands">
          <FeaturedBrands />
        </div>
      </div>
    </>
  );
}

export default Home;
